import React from 'react';
import { Button } from '@naf-simba/elements-buttons';
import styled from '@emotion/styled';
import { resolveLinkProps } from '@lib/resolveLinkProps';
import { ExternalGlobalCTAType } from './index';
import useSelector from '../../../../../../redux/typedHooks';
import { useTrackCTA } from '../../../../../../utils/Tracking/CtaClick/TrackCtaClick';
import { useTrackPromotion } from '../../../../../../hooks/useTrackPromotion';
import { getPromotionEventTrackingData } from '../../../../../../utils/Tracking/Promotion/getPromotionEventTrackingData';

interface Props {
  data: ExternalGlobalCTAType['data'];
}

// TODO: This and InternalLink component can be single component - leaving as it is for further refactor later. DL
export const ExternalUrl = ({ data }: Props) => {
  const baseUrl = useSelector((state) => state.application.baseUrl);
  const trackCTA = useTrackCTA();
  const linkProps = resolveLinkProps({ url: data.url, baseUrl, blank: data.blank });
  const resolvedUrl = 'to' in linkProps ? (linkProps as { to: string }).to : data.url;
  const promotion = getPromotionEventTrackingData(data.buttonText, resolvedUrl);
  const shouldTrackPromotion = Boolean(promotion);
  const { wrapperRef, trackSelectPromotion } = useTrackPromotion({
    creative_slot: 'external-url',
    creative_name: `CTA | ${data.buttonText}`,
    promotion_id: promotion?.promotion_id,
    promotion_name: promotion?.promotion_name,
  });

  const handleTracking = () => {
    if (shouldTrackPromotion) {
      trackSelectPromotion();
    }
    try {
      const urlObject = new URL(data.url);
      trackCTA({
        cta_position: 'content',
        text: data.buttonText,
        url: data.url,
        cta_hostname: urlObject.hostname,
      });
    } catch {
      trackCTA({ cta_position: 'content', text: data.buttonText, url: data.url });
    }
  };

  return (
    <Wrapper ref={shouldTrackPromotion ? wrapperRef : undefined}>
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <Button onClick={handleTracking} {...linkProps}>
        {data.buttonText}
      </Button>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  margin-bottom: 16px;
`;
